var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSorting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sorting") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-3-Copy-15",
    transform: "translate(-1141.000000, -932.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(1129.000000, 923.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sorting",
    transform: "translate(12.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00001287,9.13804275 L9.55485611,11.8047089 C9.80429398,12.0650644 10.2086405,12.0650644 10.4580784,11.8047089 L13.0129216,9.13804275 C13.2623595,8.87768724 13.2623595,8.45564288 13.0129216,8.19528737 C12.7634837,7.93493186 12.3591372,7.93493186 12.1096994,8.19528737 L10.645178,9.72382042 L10.645178,0.666666543 C10.645178,0.298479945 10.3592059,0 10.0064672,0 C9.65372855,0 9.36775643,0.298479945 9.36775643,0.666666543 L9.36775643,9.72382042 L7.90323512,8.19528737 C7.65379726,7.93493186 7.24945073,7.93493186 7.00001287,8.19528737 C6.75057501,8.45564288 6.75057501,8.87768724 7.00001287,9.13804275 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6451886,0.195262186 C3.39575925,-0.0650844324 2.9913446,-0.0650844324 2.74191525,0.195262186 L0.187072009,2.86192836 C-0.0623573364,3.12227498 -0.0623573364,3.54439045 0.187072009,3.80473707 C0.436501355,4.06508369 0.840916008,4.06508369 1.09034535,3.80473707 L2.55484111,2.2761418 L2.55484111,11.3333312 C2.55484111,11.7015089 2.84080472,12.0000022 3.19355192,12.0000022 C3.54629913,12.0000022 3.83226273,11.7015089 3.83226273,11.3333312 L3.83226273,2.2761418 L5.29678404,3.80473707 C5.5462219,4.06508369 5.95056843,4.06508369 6.20000629,3.80473707 C6.44944415,3.54439045 6.44944415,3.12227498 6.20000629,2.86192836 L3.6451886,0.195262186 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorting);
export default __webpack_public_path__ + "static/media/sorting.04b32a10f4278b509da2b112af9222b7.svg";
export { ForwardRef as ReactComponent };